export type PaidMediaTabId =
  | "overview"
  | "meta-ads-report"
  | "google-ads-report"
  | "tiktok-ads-report";

export const PAID_MEDIA_TAB_ITEMS: Array<{ id: PaidMediaTabId; label: string }> = [
  { id: "overview", label: "Paid Media Overview" },
  { id: "meta-ads-report", label: "Meta Ads Report" },
  { id: "google-ads-report", label: "Google Ads Report" },
];
